/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { PlaceDto } from '../../models/place-dto';
import { UpdatePlaceDto } from '../../models/update-place-dto';

export interface PlaceControllerUpdate$Params {
  id: string;
      body: UpdatePlaceDto
}

export function placeControllerUpdate(http: HttpClient, rootUrl: string, params: PlaceControllerUpdate$Params, context?: HttpContext): Observable<StrictHttpResponse<PlaceDto>> {
  const rb = new RequestBuilder(rootUrl, placeControllerUpdate.PATH, 'patch');
  if (params) {
    rb.path('id', params.id, {});
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<PlaceDto>;
    })
  );
}

placeControllerUpdate.PATH = '/api/places/{id}';
